module.exports = __webpack_public_path__ + "fonts/akkurat_bold-webfont.f4bb1975.woff2";